import * as React from "react"
import { useState } from "react";
import TextWithLinksParser from "../../TextWithLinksParser"
import ProductContentStyle1 from "../content/ProductContentStyle1";
import ProductContentStyle2 from "../content/ProductContentStyle2";
import ProductContentStyle3 from "../content/ProductContentStyle3";
import ProductContentStyle4 from "../content/ProductContentStyle4";
import ProductContentStyle5 from "../content/ProductContentStyle5";
import ProductContentStyle7 from "../content/ProductContentStyle7";
import ProductContentStyle8 from "../content/ProductContentStyle8";
import ProductContentStyle6 from "../content/ProductContentStyle6";
import { PRODUCT_TYPE_CARBON } from "../../constants";

export default function ProductItem({ itemData, isProductPassportView }) {
    const [isOpen, setIsOpen] = useState(!itemData.collapsed);
    const [selectedType, setSelectedType] = useState(PRODUCT_TYPE_CARBON);

    const toggleBlock = (status) => {
        setIsOpen(!status);
    }

    const showStyle3 = itemData?.style === 'style_3' && itemData.info.find(item => !Number(item.count));
    const showStyle4 = itemData?.style === 'style_4' && (itemData?.info?.length === 0 || itemData?.info.find(item => !item.organisation_info && !item.certificate_number));

    return !!itemData.title && (
        <div
            id={`${itemData.style}`}
            className={`product-item ${isOpen ? 'active' : ''}
                        ${(showStyle4 || showStyle3) ? 'd-none' : ''}`}
        >
            <div
                className={`product-item-title toggle`}
                onClick={() => toggleBlock(isOpen)}
            >
                <div className="info">
                    <div className="title">
                        {itemData.title}
                        <img src='/images/arrow-expand.svg' alt="" className={`expand ${isOpen ? 'on' : ''}`} />
                    </div>
                </div>
            </div>

            <div className={`product-item-content`}>
                <div className={`product-content-wrapper ${itemData?.style === 'style_8' ? 'custom' : ''}`}>
                    {!!itemData?.description && (
                        <p className={`item-description ${itemData?.style === 'style_6' ? 'care' : ''}`}>
                            <TextWithLinksParser text={itemData?.description} />
                        </p>
                    )}

                    {!!itemData?.transportation && (
                        <div className="transportation">
                            <div className="title"> {itemData.transportation.name}</div>
                            <div className={`location-wrapper`}>
                                <img src={itemData.transportation.map} alt="" />
                            </div>
                        </div>
                    )}

                    {itemData?.style === 'style_2' && (
                        <div className="product-type">
                            {itemData?.info?.map((item, index) => {
                                    const displayItemTitle = !!Number(item.info_data.count) && !item.info_progress?.every(item => !Number(item.progress));

                                    return (displayItemTitle && (
                                            <button
                                                key={index}
                                                type="button"
                                                onClick={() => setSelectedType(item.title)}
                                                className={`type ${selectedType === item.title ? 'active' : ''}`}
                                            >
                                                <p>{item.title}</p>
                                            </button>
                                        )
                                    )
                                }
                            )}
                        </div>
                    )}

                    {itemData?.style === 'style_1' &&
                        <ProductContentStyle1
                            items={itemData.info}
                            itemData={itemData}
                        />
                    }

                    {itemData?.style === 'style_2' &&
                        <ProductContentStyle2
                            items={itemData.info}
                            selectedType={selectedType}
                        />
                    }

                    {itemData?.style === 'style_3' &&
                        <ProductContentStyle3
                            items={itemData.info}
                        />
                    }

                    {itemData?.style === 'style_4' &&
                        <ProductContentStyle4
                            items={itemData.info}
                        />
                    }

                    {itemData?.style === 'style_5' &&
                        <ProductContentStyle5
                            items={itemData.info}
                        />
                    }


                    {itemData?.style === 'style_6' &&
                        <ProductContentStyle6
                            items={itemData.info}
                        />
                    }

                    {itemData?.style === 'style_7' &&
                        <ProductContentStyle7
                            items={itemData.info}
                            isProductPassportView={isProductPassportView}
                        />
                    }

                    {itemData?.style === 'style_8' &&
                        <ProductContentStyle8
                            items={itemData.info}
                        />
                    }
                </div>
            </div>
        </div>
    )
}
